/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { WorkingMachineDto } from '../../../AutoGeneratedAPI/clientApi';
import { GranitClient } from '../../../AutoGeneratedAPI/Extension';
import { ExceptionsWithAdding, ExceptionsWithUpdating } from '../../../Extensions/Exceptions';
import { addHandMachine, updateHandMachine } from '../../Reducers/WorkingTools/HandMachinesReducer';
import { changeCurrentEntity } from '../../Reducers/General/CurrentEntityReducer';

export const addNewHandMachine = (handMachine: WorkingMachineDto | WorkingMachineDto | undefined) => (
    dispatch: (arg0: { payload: any; type: string }) => void,
) => {
    {
        GranitClient.addNewWorkingMachine(handMachine as WorkingMachineDto).then(
            (result) => {
                dispatch(addHandMachine(result));
            },
            (error) => {
                alert(ExceptionsWithAdding.EXCEPTION_ADDING_HANDMACHINES);
                console.log(error.message);
            },
        );
    }
};

export const updateOldHandMachine = (
    handMachine: WorkingMachineDto | WorkingMachineDto | undefined,
    oldHandMachine?: WorkingMachineDto | WorkingMachineDto,
) => (dispatch: (arg0: { payload: any; type: string }) => void) => {
    GranitClient.updateWorkingMachine(
        handMachine !== undefined ? (handMachine.id as number) : 0,
        handMachine as WorkingMachineDto,
    ).then(
        (result) => {
            dispatch(changeCurrentEntity(result));
            dispatch(updateHandMachine(handMachine as WorkingMachineDto, oldHandMachine));
        },
        (error) => {
            alert(ExceptionsWithUpdating.EXCEPTION_UPDATING_HANDMACHINES);
            console.log(error.message);
        },
    );
};
